import styled from '@emotion/styled';
import { isPC } from 'constants/layout';
import { getCoverImageBorder, getCoverImageStyle } from 'styles/common';
import { IkImage } from 'ui-components/Imagekit/IkImage';

interface SelectDefaultCoverImageListProps {
  className?: string;
  onSelected: (imageFilePath: string) => void;
  imageFilePaths: string[];
}

const ImageItemIndent = 16;

export const SelectDefaultCoverImageList = ({
  className,
  imageFilePaths,
  onSelected,
}: SelectDefaultCoverImageListProps) => (
  <StyledList className={className}>
    {imageFilePaths.map(imageFilePath => (
      <StyledItem key={imageFilePath} onClick={() => onSelected(imageFilePath)}>
        <IkImage src={imageFilePath} alt="Cover" />
      </StyledItem>
    ))}
  </StyledList>
);

const StyledList = styled.ul`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  justify-content: space-between;
  padding: 1px 2px;
  overflow-y: auto;
  overscroll-behavior-y: contain;
  position: relative;
`;

const StyledItem = styled.li`
  width: 32%;
  display: inline-block;
  position: relative;
  ${getCoverImageBorder()};
  cursor: pointer;

  &::before {
    position: initial;
  }

  &:nth-of-type(n + 4) {
    margin-top: ${ImageItemIndent}px;
  }

  @media (${isPC}) {
    width: 105px;
    height: 160px;
    &:nth-of-type(n + 4) {
      margin-top: 0;
    }

    &:nth-of-type(n + 5) {
      margin-top: ${ImageItemIndent}px;
    }
  }

  img {
    ${getCoverImageStyle()}
  }
`;
